import { render, staticRenderFns } from "./cooperate.vue?vue&type=template&id=47a9584a&scoped=true&"
import script from "./cooperate.vue?vue&type=script&lang=js&"
export * from "./cooperate.vue?vue&type=script&lang=js&"
import style0 from "./cooperate.vue?vue&type=style&index=0&id=47a9584a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9584a",
  null
  
)

export default component.exports